import { Stack, Typography } from "@mui/material";
import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";
import { type FC, useMemo } from "react";
import { CsvExportButton } from "../../../../modules/generic/components/csv-export-button";
import type { GroupedMomentAnalyticsData } from "../../../../modules/stats/server/analytics-service";

export const AnalyticsSendsTableMissingOpens: FC<{
  deliveries: Extract<
    GroupedMomentAnalyticsData["stats"][number],
    { stat_type: "delivery" }
  >["data"][];
}> = ({ deliveries }) => {
  const rows = useMemo(() => {
    return deliveries.map((item, id) => {
      return {
        id,
        first_name: item.recipient_data?.first_name ?? "-",
        last_name: item.recipient_data?.last_name ?? "-",
        email: item.recipient_data?.display ?? "-",
      };
    });
  }, [deliveries]);

  const columns = useMemo(() => {
    const columnData: GridColDef<(typeof rows)[0]>[] = [
      {
        field: "first_name",
        headerName: "First Name",
        flex: 1,
      },
      {
        field: "last_name",
        headerName: "Last Name",
        flex: 1,
      },
      {
        field: "email",
        headerName: "Work Email",
        flex: 1,
      },
    ];
    return columnData;
  }, []);

  if (rows.length === 0) return null;

  return (
    <Stack spacing={1} direction="column">
      <Typography variant="body2">
        It looks like{" "}
        <strong>{`${deliveries.length} ${deliveries.length === 1 ? "person" : "people"}`}</strong>{" "}
        who received this Communication {deliveries.length === 1 ? "has" : "have"}{" "}
        <strong>not</strong> opened it yet, but we don’t always get accurate figures for this.
      </Typography>
      <DataGridPro
        pagination
        pageSizeOptions={[10, 25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        rows={rows}
        columns={columns}
        disableRowSelectionOnClick
        slots={{ toolbar: CsvExportButton }}
        showToolbar
      />
    </Stack>
  );
};
